<div [ngClass]="{'page-container': this.showHeader}">
  
  <!---------------------------->
  <!-- Header Filters -->
  <!---------------------------->
  
  @if (showHeader) {
    <div class="flex flex-wrap justify-start mt2 mb2">

      <!---------------------------->
      <!-- Route ID DDN-->
      <!---------------------------->
      <div class="mr2 w-20">
        <div class="flex">
          <mat-form-field class="w-90">
            <mat-label>Route ID</mat-label>
            <input type="text"
                   placeholder="Search by route ID"
                   matInput
                   #routeIdInput
                   [formControl]="routeIdControl"
                   [matAutocomplete]="routeIdAuto"
                   #routeIdAutoTrigger="matAutocompleteTrigger"
                   (input)="filterRouteIds($event)"
                   (focus)="showAllRouteIds()">
            @if (routeIdControl.value && routeIdControl.value !== allOptions) {
              <button mat-icon-button matSuffix type="button" aria-label="Clear"
                      (click)="clearRouteId(routeIdInput, routeIdAutoTrigger)">
                <mat-icon class="route-id-clear-icon">close</mat-icon>
              </button>
            }
            <mat-autocomplete requireSelection #routeIdAuto="matAutocomplete"
                              (optionSelected)="onRouteIdOptionSelected($event.option.value)">
              @for (option of filteredRouteIDTypes; track option) {
                <mat-option [value]="option">{{option}}</mat-option>
              }
            </mat-autocomplete>
          </mat-form-field>
          <mat-icon class="info-icon ml1" [matTooltip]="'Select Route ID'">help_outline</mat-icon>
        </div>
      </div>
      
      <!---------------------------->
      <!-- Is Consumed DDN-->
      <!---------------------------->
      <div class="mr2">
        <div class="flex">
          <app-element-select displayLabel="Is Consumed"
                              [defaultValue]="allOptions"
                              [options]="consumedStatuses"
                              (selectionChanged)="onSelectionChange($event, tableColumns.IsConsumed)"></app-element-select>
          <mat-icon class="info-icon ml1" [matTooltip]="'Select if consumed'">help_outline</mat-icon>
        </div>
      </div>
      
      <!---------------------------->
      <!-- Message ID Input-->
      <!---------------------------->
      
      <div class="mr2 w-20">
        <div class="flex">
          <mat-form-field class="w-100">
            <mat-label>Search by message ID</mat-label>
            <input matInput type="text" [formControl]="searchMessageFormControl"
                   [errorStateMatcher]="immediateErrorStateMatcher"
                   (input)="onInputChangedSearchMessages($event, tableColumns.MessageId)">
            <mat-error >Please enter at least 3 characters</mat-error>
          </mat-form-field>
          <mat-icon [matTooltip]="getInfoTooltip(InputName.MessageID)" class="info-icon ml1">help_outline</mat-icon>
        </div>
      </div>
      
      <!---------------------------->
      <!-- Correlation ID Input-->
      <!---------------------------->
      <div class="mr2 w-20">
        <div class="flex">
          <mat-form-field class="w-100">
            <mat-label>Search by correlation ID</mat-label>
            <input matInput type="text" [formControl]="searchMessageByCorrelationIdFormControl"
                   [errorStateMatcher]="immediateErrorStateMatcher"
                   (input)="onInputChangedSearchMessages($event, tableColumns.CorrelationId)">
            <mat-error >Please enter at least 3 characters</mat-error>
          </mat-form-field>
          <mat-icon [matTooltip]="getInfoTooltip(InputName.CorrelationID)" class="info-icon ml1">help_outline</mat-icon>
        </div>
      </div>

    </div>
  }

  <!---------------------------->
  <!-- Table -->
  <!---------------------------->

  @if (dataSource) {
    <div class="mat-elevation-z8 table-container">

    <table mat-table multiTemplateDataRows [dataSource]="dataSource" matSort (matSortChange)="sortData($event)">

      <ng-container [matColumnDef]="tableColumns.Id">
        <th *matHeaderCellDef mat-header-cell mat-sort-header class="w-5">ID</th>
        <td *matCellDef="let row" mat-cell>{{row[tableColumns.Id]}}</td>
      </ng-container>

      <ng-container [matColumnDef]="tableColumns.DateTime">
        <th *matHeaderCellDef mat-header-cell class="w-10">Date</th>
        <td *matCellDef="let row" mat-cell>{{row[tableColumns.DateTime] | date: dateTimeFormat}}</td>
      </ng-container>

      <ng-container [matColumnDef]="tableColumns.MessageId">
        <th *matHeaderCellDef mat-header-cell mat-sort-header class="w-10">Message Id</th>
        <td *matCellDef="let row" mat-cell [matTooltip]="row[tableColumns.MessageId]">
          {{row[tableColumns.MessageId] | truncateText: {sliceStart: 0, sliceEnd: 30, append: '...'} }}
        </td>
      </ng-container>

      <ng-container [matColumnDef]="tableColumns.CorrelationId">
        <th *matHeaderCellDef mat-header-cell mat-sort-header class="w-10">Correlation Id</th>
        <td *matCellDef="let row" mat-cell>{{row[tableColumns.CorrelationId]}}</td>
      </ng-container>

      <ng-container [matColumnDef]="tableColumns.RouteId">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>Route Id</th>
        <td *matCellDef="let row" mat-cell [matTooltip]="row[tableColumns.RouteId]">
          <div class="flex justify-start items-baseline">
            <p class="m-r-20">
              {{row[tableColumns.RouteId] | truncateText: {sliceStart: 0, sliceEnd: 100, append: '...'} }}
            </p>
          </div>
        </td>
      </ng-container>

      <ng-container [matColumnDef]="tableColumns.IsConsumed">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>Is Consumed</th>
        <td *matCellDef="let row" mat-cell>
          <span class="center-align mr2">{{ row[tableColumns.IsConsumed] === "1" ? 'Y' : 'N' }}</span>
        </td>
      </ng-container>

      <ng-container [matColumnDef]="tableColumns.Time">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>Time (s)</th>
        <td *matCellDef="let row" mat-cell>
          <span class="center-align mr2">{{ row[tableColumns.Time]/1000 | number: '.2-2' }}</span>
        </td>
      </ng-container>

      <ng-container [matColumnDef]="tableColumns.TransactionType">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>Transaction Type</th>
        <td *matCellDef="let row" mat-cell>{{ row[tableColumns.TransactionType] }}</td>
      </ng-container>

      <ng-container [matColumnDef]="tableColumns.Message">
        <th *matHeaderCellDef mat-header-cell>Request</th>
        <td *matCellDef="let row" mat-cell>
          <span class="center-align mr2">
            <mat-icon class="mat-primary-color hand-cursor mr2" matTooltip="VIEW Message"
              (click)="openClickOpenMessageDialog($event, row, tableColumns.Message)">
              article
            </mat-icon>
          </span>
        </td>
      </ng-container>

      <ng-container [matColumnDef]="tableColumns.MessageOutput">
        <th *matHeaderCellDef mat-header-cell>Response</th>
        <td *matCellDef="let row" mat-cell>
          <span class="center-align mr2">
            <mat-icon class="mat-primary-color hand-cursor mr2" matTooltip="VIEW Message"
              (click)="openClickOpenMessageDialog($event, row, tableColumns.MessageOutput)">
              article
            </mat-icon>
          </span>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>

     <mat-paginator #errorMessagesPaginator [length]="tableControl.length" [pageSize]="tableControl.pageSize"
                    [pageIndex]="0" [pageSizeOptions]="tableControl.pageSizeOptions" (page)="pageChanged($event)">
     </mat-paginator>
  </div>
  }
</div>
